/* eslint-disable import/prefer-default-export */
const dummy = {
  episodeId: 144018,
  title: 'Folge 97: Erlaubte Abtreibung oder Totschlag?',
  summary: 'weitere Themen: Anklage gegen Franco A., EuGH zu polnischer Justizreform, AGH zu elektronischem Anwaltspostfach\n\nKapitel:\n3:43 Nachtrag 1: Reform Strafverfahren\n5:15 Nachtrag 2: Assange\n9:19 Nachtrag 3: Upskirting / Gafferfotos\n14:07 Nachtrag 4: Ibrahim Miri\n15:35 Fetozid\n25:59 Franco A.\n34:28 Polnische Justizreform\n44:06 Elektronisches Anwaltspostfach\n52:35 Gerechtes Urteil',
  duration: 3453,
  audio: [
    { url: 'https://cdn.podigee.com/media/podcast_1913_faz_einspruch_episode_107_folge_97.mp4?v=1574266878&source=api', size: 151979916, mimeType: 'audio/mpeg' }, { url: 'https://cdn.podigee.com/media/podcast_1913_faz_einspruch_episode_107_folge_97.opus?v=1574266877&source=api', size: 30120626, mimeType: 'audio/opus' }, { url: 'https://cdn.podigee.com/media/podcast_1913_faz_einspruch_episode_107_folge_97.ogg?v=1574266877&source=api', size: 45331987, mimeType: 'audio/ogg' }, { url: 'https://cdn.podigee.com/media/podcast_1913_faz_einspruch_episode_107_folge_97.m4a?v=1574266877&source=api', size: 36078892, mimeType: 'audio/aac' }, { url: 'https://cdn.podigee.com/media/podcast_1913_faz_einspruch_episode_107_folge_97.mp3?v=1574266875&source=api', size: 48500889, mimeType: 'audio/mpeg' }],
  chapters: [
    {
      start: '00:00:00.000',
      title: 'Start',
    },
    {
      start: '00:03:34.000',
      title: 'Nachtrag 1: Reform Strafverfahren',
    },
    {
      start: '00:05:15.000',
      title: 'Nachtrag 2: Assange',
    },
    {
      start: '00:09:19.000',
      title: 'Nachtrag 3: Upskirting/Unfallfotos',
    },
    {
      start: '00:14:07.000',
      title: 'Nachtrag 4: Miri',
    },
    {
      start: '00:15:35.000',
      title: 'Zwillingstod',
    },
    {
      start: '00:25:59.000',
      title: 'Franco A.',
    },
    {
      start: '00:34:28.000',
      title: 'Polnische Justizreform',
    },
    {
      start: '00:44:06.000',
      title: 'Elektr. Postfach Anwälte',
    },
    {
      start: '00:52:35.000',
      title: 'Gerechtes Urteil',
    },
  ],
  playlist: [
    {
      title: 'Folge 101: Maßnahmenpaket gegen Hass im Netz',
      episodeId: 154253,
      config: '/api/154253.json',
    },
    {
      title: 'Folge 100: Jubiläumsfolge live aus München',
      episodeId: 152215,
      config: '/api/without-chapters.json',
    },
    {
      title: 'Folge 99: Auf Schmusekurs mit der NPD',
      episodeId: 148969,
      config: 'https://www.testfaz.net/podcast-service/episode/148969/',
    },
    {
      title: 'Folge 98: Doppelschlag des Bundesverfassungsgerichts',
      episodeId: 146398,
      config: 'https://www.testfaz.net/podcast-service/episode/146398/',
    },
    {
      title: 'Folge 97: Erlaubte Abtreibung oder Totschlag?',
      episodeId: 144018,
      config: 'https://www.testfaz.net/podcast-service/episode/144018/',
    },
    {
      title: 'Folge 96: Grundrente: Gut gemeint, schlecht gemacht?',
      episodeId: 141877,
      config: 'https://www.testfaz.net/podcast-service/episode/141877/',
    },
    {
      title: 'Folge 95: Wann das Existenzminimum unterschritten werden darf',
      episodeId: 139789,
      config: 'https://www.testfaz.net/podcast-service/episode/139789/',
    },
    {
      title: 'Folge 94: Berlin kappt die Mieten',
      episodeId: 134644,
      config: 'https://www.testfaz.net/podcast-service/episode/134644/',
    },
    {
      title: 'Folge 93: Inhalt und Aussichten von Johnsons Brexit-Deal',
      episodeId: 132319,
      config: 'https://www.testfaz.net/podcast-service/episode/132319/',
    },
    {
      title: 'Folge 92: Amtsenthebung auf der Zielgeraden?',
      episodeId: 129394,
      config: 'https://www.testfaz.net/podcast-service/episode/129394/',
    },
    {
      title: 'Folge 91: Thomas Fischer, Gaby Mayr und die "handwerkliche Schlamperei"',
      episodeId: 127597,
      config: 'https://www.testfaz.net/podcast-service/episode/127597/',
    },
    {
      title: 'Folge 90: Klimapaket und Künast-Urteil',
      episodeId: 125706,
      config: 'https://www.testfaz.net/podcast-service/episode/125706/',
    },
    {
      title: 'Folge 89: Warum "Upskirting" strafbar werden soll',
      episodeId: 123548,
      config: 'https://www.testfaz.net/podcast-service/episode/123548/',
    },
    {
      title: 'Folge 88: Lügde und der Wunsch nach Vergeltung',
      episodeId: 120863,
      config: 'https://www.testfaz.net/podcast-service/episode/120863/',
    },
    {
      title: 'Folge 87: Markus Söder in den Knast?',
      episodeId: 118518,
      config: 'https://www.testfaz.net/podcast-service/episode/118518/',
    },
    {
      title: 'Folge 86: Zwangsurlaub für das britische Parlament?',
      episodeId: 116730,
      config: 'https://www.testfaz.net/podcast-service/episode/116730/',
    },
    {
      title: 'Folge 85: Mietpreisbremse verlängert, verschärft, verfassungsgemäß',
      episodeId: 115037,
      config: 'https://www.testfaz.net/podcast-service/episode/115037/',
    },
    {
      title: 'Folge 84: Soli-Abschaffung und StPO-Reform',
      episodeId: 113216,
      config: 'https://www.testfaz.net/podcast-service/episode/113216/',
    },
    {
      title: 'Folge 83: Ein Wald aus Warnhinweisen',
      episodeId: 110080,
      config: 'https://www.testfaz.net/podcast-service/episode/110080/',
    },
    {
      title: 'Folge 82: Schlappen für die AfD, Sieg für die Meinungsfreiheit',
      episodeId: 108264,
      config: 'https://www.testfaz.net/podcast-service/episode/108264/',
    },
    {
      title: 'Folge 81: Ablehnung der AfD-Liste in Sachsen: Rechtsstaatliches Prinzip oder Prinzipienreiterei?',
      episodeId: 105120,
      config: 'https://www.testfaz.net/podcast-service/episode/105120/',
    },
    {
      title: 'Folge 80: Recht, Moral und Doppelmoral in der Seenotrettung',
      episodeId: 103575,
      config: 'https://www.testfaz.net/podcast-service/episode/103575/',
    },
    {
      title: 'Folge 79: #EndeGelände - Wie weit darf ziviler Ungehorsam gehen?',
      episodeId: 102105,
      config: 'https://www.testfaz.net/podcast-service/episode/102105/',
    },
    {
      title: 'Folge 78: Berlin deckelt die Mieten',
      episodeId: 100188,
      config: 'https://www.testfaz.net/podcast-service/episode/100188/',
    },
    {
      title: 'Folge 77: Groko im Gesetzgebungsrausch: Was bringt das neue Migrationsrecht?',
      episodeId: 98158,
      config: 'https://www.testfaz.net/podcast-service/episode/98158/',
    },
    {
      title: 'Folge 76: Der steinige Weg zu Neuwahlen',
      episodeId: 96497,
      config: 'https://www.testfaz.net/podcast-service/episode/96497/',
    },
    {
      title: 'Folge 75: Rezo, Kramp-Karrenbauer und das Presserecht',
      episodeId: 94585,
      config: 'https://www.testfaz.net/podcast-service/episode/94585/',
    },
    {
      title: 'Folge 74: Rechtsfragen rund ums Strachevideo',
      episodeId: 93169,
      config: 'https://www.testfaz.net/podcast-service/episode/93169/',
    },
    {
      title: 'Folge 73: Kampfansage an "Abmahnanwälte"',
      episodeId: 92104,
      config: 'https://www.testfaz.net/podcast-service/episode/92104/',
    },
  ],
  subscriptions: [
    {
      title: 'Apple Podcast',
      url: 'https://podcasts.apple.com/de/podcast/idid1392911377',
    },
    {
      title: 'Spotify',
      url: 'https://open.spotify.com/show/2tKSpYEvw02J8Bl19ZXStB?si=ukbYupN5TmCndDd9n9yhFQ',
    },
    {
      title: 'Alexa Skill',
      url: 'https://www.amazon.de/dp/B07FFT6F9J',
    },
    {
      title: 'Google Podcasts',
      url: 'https://www.google.com/podcasts?feed=aHR0cHM6Ly9kaWdpdGVjLnBvZGlnZWUuaW8vZmVlZC9tcDM%3D',
    },
  ],
  version: 5,
};
export {
  dummy,
};
